import {connect} from 'react-redux'
import MenuLineBoxes from '../components/MenuLineBoxes'
import {selectMenuLines} from '../../../redux/selectors/selectors'

const mapStateToProps = (state) => ({
  menuLines: selectMenuLines(state),
})

export default connect(mapStateToProps)(MenuLineBoxes)
